module.exports = __webpack_public_path__ + "img/polygon-r.4f46c981.svg";